import { getSection } from '../utils';
import MarkdownText from '../MarkdownText';

const SIGNATURE = '— Le Cabinet Benchory, votre partenaire de pilotage';

/**
 * Lettre du cabinet — encadré central avec liseré bordeaux à gauche.
 * Lit prioritairement les champs structurés `salutation` / `paragraphs` /
 * `signature` produits par Claude (cf. brief Niveau 2 letter), tombe en
 * fallback sur le `content_md` rich markdown, et termine par un placeholder
 * élégant si la section n'est pas encore générée.
 */
export default function LetterCabinet({ report }) {
  const section = getSection(report, 'letter');
  const data = section?.content_data || {};
  const salutation = data.salutation || 'Cher dirigeant';
  const paragraphs = Array.isArray(data.paragraphs) ? data.paragraphs : null;
  const signature = data.signature || SIGNATURE;

  return (
    <section
      className="bg-cabinet-paper border-l-[3px] border-l-cabinet-bordeaux border-y border-r border-cabinet-border shadow-sm pl-10 pr-10 py-12"
      data-testid="letter-cabinet"
    >
      <h3 className="font-playfair text-[17px] text-cabinet-bordeaux mb-6">
        {salutation},
      </h3>

      {paragraphs ? (
        <div className="space-y-5">
          {paragraphs.map((p, i) => (
            <p key={i} className="font-playfair text-[15px] text-cabinet-ink leading-[1.85]">
              {p}
            </p>
          ))}
        </div>
      ) : section?.content_md ? (
        <MarkdownText
          text={section.content_md}
          className="font-playfair text-[15px] text-cabinet-ink leading-[1.85]"
        />
      ) : (
        <p className="font-playfair italic text-[14px] text-cabinet-ink-soft leading-[1.85]">
          La lettre du cabinet sera disponible dès la finalisation du prompt système maître.
        </p>
      )}

      <div className="mt-10 pt-6 border-t border-cabinet-border">
        <p className="font-playfair italic text-[13px] text-cabinet-ink-secondary">{signature}</p>
      </div>
    </section>
  );
}
